import React from 'react';
import cx from 'classnames';
import { useWindowSize } from '../../../../../utils/hooks/useWindowSize.js';
import styles from './index.module.scss.js';

const Row = ({
  gap,
  gapValue,
  children,
  noMobile,
  relative
}) => {
  const { windowSize } = useWindowSize();
  if (noMobile && windowSize.width < 768) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, {
        [styles["with-gap"]]: gap,
        [styles.relative]: relative
      }, "modal-element-row"),
      style: {
        ...gapValue ? { gap: gapValue } : {}
      }
    },
    children
  );
};
Row.displayName = "Auth.Form.Row";

export { Row };
//# sourceMappingURL=index.js.map
